import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const http = axios.create({ baseURL: `${BASE}/api`, withCredentials: true });

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (typeof e?.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return typeof detail?.msg === "string" ? detail.msg : String(detail);
};

const withRefresh = async (fn) => {
  try {
    return await fn();
  } catch (e) {
    if (e?.response?.status !== 401) throw e;
    await http.post("/auth/refresh");
    return fn();
  }
};

export const adminLogin = (email, password) => http.post("/auth/login", { email, password }).then((r) => r.data);
export const adminLogout = () => http.post("/auth/logout");
export const adminMe = () => withRefresh(() => http.get("/auth/me")).then((r) => r.data);
export const adminWaitlist = () => withRefresh(() => http.get("/admin/waitlist")).then((r) => r.data);
export const adminCreators = () => withRefresh(() => http.get("/admin/creators")).then((r) => r.data);
export const approveCreator = (id) => withRefresh(() => http.post(`/admin/creators/${id}/approve`)).then((r) => r.data);
export const declineCreator = (id) => withRefresh(() => http.post(`/admin/creators/${id}/decline`)).then((r) => r.data);
export const applyCreator = (body) => http.post("/creators/apply", body).then((r) => r.data);
export const checkCreatorCode = (code) => http.get("/creators/check", { params: { code } }).then((r) => r.data);

export const downloadCsv = async () => {
  const res = await withRefresh(() => http.get("/admin/waitlist.csv", { responseType: "blob" }));
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = "lunelle-waitlist.csv";
  a.click();
  URL.revokeObjectURL(url);
};
